// Types
import { NavbarButtonProps } from 'component-library/navbar-button'

// Assets
import logoPe from 'assets/logo-pe.png'
import logoPmd from 'assets/logo-pmed.png'

type NavOption = {
  source: string
  label: string
  buttonVariant?: NavbarButtonProps['variant']
}

type ContentOption = {
  label: string
  image: string
  handleClick: () => void
}

export default {
  navOptions: [
    {
      source: 'https://www.proenem.com.br/',
      label: 'Home'
    },
    {
      source: 'https://www.proenem.com.br/#turmas',
      label: 'Cursos'
    },
    {
      source: 'https://www.proenem.com.br/#apostilas',
      label: 'Apostilas'
    },
    {
      source: 'https://www.proenem.com.br/#aprovados-slider',
      label: 'Aprovados'
    },
    {
      source: 'https://atendimento.proenem.com.br/',
      label: 'Dúvidas'
    }
  ] as NavOption[],
  floatContainerContent: [
    {
      label: 'Acessar Proenem',
      source: 'https://app.proenem.com.br',
      buttonVariant: 'secondary'
    },
    {
      label: 'Acessar Promedicina',
      source: 'https://app.promedicina.com.br',
      buttonVariant: 'info'
    }
  ] as NavOption[],
  dropdownListContent: [
    {
      label: 'Acessar Proenem',
      image: logoPe,
      handleClick: () => window.open('https://app.proenem.com.br', '_blank')
    },
    {
      label: 'Acessar Promedicina',
      image: logoPmd,
      handleClick: () => window.open('https://app.promedicina.com.br', '_blank')
    }
  ] as ContentOption[]
}
